<script lang="ts">
export default defineComponent({
	name: "TabsSample",

	components: {},

	data() {

		return {
			tabs: [
				{ id: 1, name: "Вкладка 1" },
				{ id: 2, name: "Вкладка 2" },
			],
			activeTab: { id: 1 }
		}
	},

	methods: {
		onUpdateActiveTab(tab) {
			if (this.activeTab.id !== tab.id) {
				this.activeTab = { ...tab };
			}
		}
	}
});
</script>

<template>
	<VTabs
		theme="compact"
		:tabs="tabs"
		:active-tab="activeTab"
		@update:active-tab="onUpdateActiveTab"
	/>
	<br><br>
	<pre>
Active tab: {{ activeTab }}
	</pre>
</template>

